export enum SimulatorType {
  CAPACITY = 'capacity',
  PURCHASE = 'purchase',
  RENEGOTIATION = 'renegotiation',
}

export enum TitleTags {
  H1 = 'h1',
  H2 = 'h2',
  H3 = 'h3',
}

export enum Illustration {
  COUPLE = 'couple',
  HOUSE = 'house',
  SATISFIED = 'satisfied',
  SINGLE = 'single',
}

export enum InputComponent {
  DATE = 'date',
  RADIO = 'radio',
  SLIDER = 'slider',
}

type ErrorProps = {
  flag?: string
  onClickButton: () => void
}

type GraphProps = {
  bars: {
    duration: number
    isActive: boolean
    principal: number
    totalCost: number
    totalPayment: number
  }[]
  paymentSteps: number[]
  principalSteps: number[]
} | null

type InputBlocks = {
  illustration: Illustration
  inputs: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    props: any
    type: InputComponent
  }[]
  title: string
}[]

type ResultProps = {
  capacity?: number
  confidenceLevel?: number
  creditCost: number
  duration?: number
  isEmpty?: boolean
  isOverlayVisible?: boolean
  onClickButton: () => void
  payment: number
  rate: number
  savings?: number
}

export type SimulatorRowInputsProps = {
  inputBlocks: InputBlocks
  onClickComplete: () => void
}

export interface SimulatorRowProps extends SimulatorRowInputsProps {
  errorProps: ErrorProps
  graphProps: GraphProps
  isError?: boolean
  isGraphActive?: boolean
  onClickComplete: () => void
  onClickDescriptionButton: () => void
  resultProps: ResultProps
  title?: string
  titleTag?: TitleTags
  type: SimulatorType
}
